var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAssignmentFill = function SvgAssignmentFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "assignment_fill_svg__a",
    width: 23,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h23v23H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#assignment_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M5.096 19.646q-.715 0-1.224-.51a1.67 1.67 0 0 1-.509-1.223V5.087q0-.716.51-1.224.507-.51 1.223-.509H9.36a2.12 2.12 0 0 1 .697-1.357q.606-.56 1.457-.56.85 0 1.457.56.606.56.687 1.357h4.265q.714 0 1.223.51.51.507.509 1.223v12.826q0 .716-.509 1.224-.51.51-1.224.509zm2.58-3.705h4.791a.7.7 0 0 0 .512-.206.7.7 0 0 0 .207-.513.7.7 0 0 0-.207-.512.7.7 0 0 0-.512-.206H7.676a.7.7 0 0 0-.512.207.7.7 0 0 0-.207.512q0 .306.207.512a.7.7 0 0 0 .512.207m0-3.722h7.666a.7.7 0 0 0 .512-.207.7.7 0 0 0 .207-.512.7.7 0 0 0-.207-.512.7.7 0 0 0-.512-.207H7.676a.7.7 0 0 0-.512.207.7.7 0 0 0-.207.512q0 .306.207.512a.7.7 0 0 0 .512.207m0-3.723h7.666a.7.7 0 0 0 .512-.207.7.7 0 0 0 .207-.512.7.7 0 0 0-.207-.512.7.7 0 0 0-.512-.207H7.676a.7.7 0 0 0-.512.207.7.7 0 0 0-.207.513q0 .305.207.512a.7.7 0 0 0 .512.206m3.833-4.331a.7.7 0 0 0 .719-.719.7.7 0 0 0-.719-.718.7.7 0 0 0-.719.718.7.7 0 0 0 .72.719"
  }))));
};
export default SvgAssignmentFill;